import { InternalServerError } from "./base.error.js";

export class InvalidParticipantStateError extends InternalServerError {
  constructor(invalidValue: string) {
    super(
      `Invalid participant state: "${invalidValue}". Valid states: PENDING, INVITED, CONTACTED, JOINED, REMOVED`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidParticipantStateError",
    });
  }
}
